export default {
  desktopWidth: 1200,
  tabletWidth: 768
}
